(() => {
  if (customElements.get('mp-yield-summary')) return;
  customElements.define('mp-yield-summary', class extends HTMLElement {
    connectedCallback() {
      this.bind = () => {
        const calculator = [...document.querySelectorAll('mp-product-savings')].find(node => node.dataset.productId === this.dataset.productId);
        if (!calculator || calculator === this.calculator) return;
        this.observer?.disconnect();
        this.calculator = calculator;
        const sync = () => {
          const read = name => calculator.querySelector('[data-savings-output="' + name + '"]')?.textContent.trim() || '';
          this.querySelectorAll('[data-mp-yield-value]').forEach(node => {
            const value = read(node.dataset.mpYieldValue);
            if (node.textContent !== value) node.textContent = value;
          });
          const hasPayback = /^[0-9]/.test(read('payback'));
          this.querySelector('[data-mp-yield-payback]').hidden = !hasPayback;
          this.querySelector('[data-mp-yield-unavailable]').hidden = hasPayback;
          this.hidden = !read('savings') || !read('self_used') || Boolean(calculator.querySelector('[aria-invalid="true"]'));
        };
        this.observer = new MutationObserver(sync);
        this.observer.observe(calculator, { childList:true, characterData:true, subtree:true, attributes:true, attributeFilter:['aria-invalid'] });
        sync();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.bind, { once:true }); else this.bind();
      document.addEventListener('shopify:section:load', this.bind);
      this.setupMobilePurchase();
    }
    setupMobilePurchase() {
      const buybox = this.closest('[data-mp-buybox]');
      const row = buybox?.querySelector('.mp-purchase-row');
      const price = buybox?.querySelector('.mp-set-summary__price, .mp-configuration-summary__price');
      const paypal = buybox?.querySelector('[data-mp-paypal-pay-later]');
      if (!row || !price || !paypal || buybox.querySelector('.mp-set-summary__buy-grid')) return;
      this.price = price;
      this.paypal = paypal;
      this.priceMarker = document.createComment('price position');
      this.paypalMarker = document.createComment('PayPal position');
      price.before(this.priceMarker);
      paypal.before(this.paypalMarker);
      this.mobile = matchMedia('(max-width:640px)');
      this.layout = () => {
        row.classList.toggle('mp-purchase-row--mobile-set', this.mobile.matches);
        if (this.mobile.matches) { row.prepend(price); row.insertBefore(paypal, row.querySelector('[data-mp-add]')); }
        else { this.priceMarker.after(price); this.paypalMarker.after(paypal); }
      };
      this.mobile.addEventListener('change', this.layout);
      this.layout();
      const badge = document.createElement('span');
      badge.className = 'mp-mobile-set-saving';badge.hidden = true;price.append(badge);
      const amount = value => {
        const cleaned = value.replace(/[^0-9,.-]/g,'');
        return Number(cleaned.includes(',') ? cleaned.replace(/\./g,'').replace(',','.') : cleaned);
      };
      const syncDiscount = () => {
        const current = price.querySelector('ins'), previous = price.querySelector('del');
        const difference = current && previous && !previous.hidden ? Math.round((amount(previous.textContent)-amount(current.textContent))*100) : 0;
        const hideBadge = !this.mobile.matches || difference <= 0;
        if (badge.hidden !== hideBadge) badge.hidden = hideBadge;
        const value = difference > 0 ? '−' + new Intl.NumberFormat(document.documentElement.lang || 'de', { style:'currency',currency:buybox.dataset.currency || 'EUR' }).format(difference/100) : '';
        if(badge.textContent !== value)badge.textContent = value;
      };
      this.priceObserver = new MutationObserver(syncDiscount);
      this.priceObserver.observe(price,{childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['hidden']});
      this.mobile.addEventListener('change',syncDiscount);
      this.discountListener = syncDiscount;
      syncDiscount();
    }
    disconnectedCallback() {
      this.observer?.disconnect();this.priceObserver?.disconnect();
      document.removeEventListener('shopify:section:load',this.bind);
      this.mobile?.removeEventListener('change',this.layout);
      this.mobile?.removeEventListener('change',this.discountListener);
    }
  });
})();
